// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1pvIL","footer":"Form_footer__acKkh"};